export const SITE_ROUTE_PREFIX = '/sites/:sitePublicId';

const normalizeLogicalPath = (path: string): string => {
  const trimmed = path.trim();
  if (!trimmed || trimmed === '/') return '/';
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const toSiteRoutePattern = (logicalPath: string): string => {
  const normalized = normalizeLogicalPath(logicalPath);
  return normalized === '/' ? SITE_ROUTE_PREFIX : `${SITE_ROUTE_PREFIX}${normalized}`;
};

export const toSitePagePath = (sitePublicId: string, logicalPath: string): string => {
  const normalized = normalizeLogicalPath(logicalPath);
  const prefix = `/sites/${encodeURIComponent(sitePublicId.trim())}`;
  return normalized === '/' ? prefix : `${prefix}${normalized}`;
};

export const getSitePublicIdFromPagePath = (pathname: string): string | null => {
  const match = /^\/sites\/([^/]+)(?:\/|$)/.exec(pathname);
  if (!match) return null;
  try {
    return decodeURIComponent(match[1]).trim() || null;
  } catch {
    return null;
  }
};

export const stripSitePagePrefix = (pathname: string): string => {
  const match = /^\/sites\/[^/]+(\/.*)?$/.exec(pathname);
  return match ? match[1] || '/' : pathname;
};

export const replaceSiteInPagePath = (
  pathname: string,
  sitePublicId: string,
): string => toSitePagePath(sitePublicId, stripSitePagePrefix(pathname));
